import {
  buildHead,
  COMPANY,
  type HeadResult,
  type PageHeadOptions,
} from "./seo";
import type { Locale } from "./i18n";

export function buildCorporateHead(options: PageHeadOptions): HeadResult {
  const result = buildHead(options);
  if (options.locale !== "es") return result;

  return {
    ...result,
    meta: result.meta.map((tag) => {
      if (tag.property === "og:locale") return { ...tag, content: "es_MX" };
      return tag;
    }),
  };
}

// The canonical Organization node (same @id: `${COMPANY.url}#org`) is
// declared once, in seo.ts's organizationJsonLd(), and injected sitewide by
// __root.tsx on every route. Pages must not re-declare it: two objects
// sharing that @id with different property sets is exactly what the
// schema.org validator flagged as an error across the marketing pages.

export function corporateProfessionalServiceJsonLd(locale: Locale) {
  const hq = COMPANY.offices[0];
  return {
    "@context": "https://schema.org",
    "@type": ["ProfessionalService", "LocalBusiness"],
    "@id": `${COMPANY.url}/#localbusiness`,
    name: `${COMPANY.name}, Shopify Select Partner`,
    image: `${COMPANY.url}/og-default-v2.jpg`,
    logo: `${COMPANY.url}/brand/shugert-wordmark-black.svg`,
    url: COMPANY.url,
    telephone: COMPANY.phone,
    email: COMPANY.email,
    description:
      locale === "es"
        ? "Firma de ingeniería Shopify para marcas DTC y B2B establecidas. Rendimiento, conversión, SEO técnico, migraciones, aplicaciones, integraciones, Shopify Plus e ingeniería continua."
        : "Shopify engineering firm for established DTC and B2B brands across performance, conversion, technical SEO, migrations, applications, integrations, Shopify Plus and ongoing engineering.",
    priceRange: "$$$",
    areaServed: ["United States", "Mexico", "Spain", "Latin America", "Europe"],
    address: {
      "@type": "PostalAddress",
      streetAddress: hq.street,
      addressLocality: hq.city,
      addressRegion: hq.region,
      addressCountry: hq.country,
      postalCode: hq.postal,
    },
    parentOrganization: { "@id": `${COMPANY.url}#org` },
    availableLanguage: ["English", "Spanish"],
  };
}
